export default __webpack_public_path__ + "static/media/stock1.177fd449.jpg";